import React from 'react';
import { useNavigate } from 'react-router-dom';

function NavBar({ authEmail, onLoginClick }) {
  const navigate = useNavigate();

  return (
    <nav className="app-nav">
      <button
        type="button"
        className="app-nav-brand app-nav-brand-btn"
        onClick={() => navigate('/')}
        aria-label="Go to home"
      >
        <span className="app-nav-logo">📐</span>
        <span className="app-nav-title">Math Tutor</span>
      </button>
      <div className="app-nav-user">
        {authEmail ? (
          <span className="app-nav-email">{authEmail}</span>
        ) : (
          <button type="button" className="app-nav-login" onClick={onLoginClick}>
            Log in
          </button>
        )}
      </div>
    </nav>
  );
}

export default NavBar;
